
import './App.css';
import { createContext, useContext, useState } from 'react';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { currentSite } from "../src/Config/siteConfig";
import Home from "./Pages/Home";
import Aboutus from './Pages/Aboutus';
import Contactus from './Pages/Contactus';
import Hardware from './Pages/Hardware';
import Partners from './Pages/Partners';
import ResearchandDevelopment from './Pages/ResearchandDevelopment';
import Ourips from './Pages/Ourips';
import Publications from './Pages/Publications';
import Services from './Pages/Services'
import Software from './Pages/Software';
import QForte from "./Pages/ProductPages/QForte"
import PageNotFound from './Pages/PageNotFound'; 
import ECDL from './Pages/ProductPages/ECDL';
import EPSQKD from './Pages/ProductPages/EPSQKD';
import QNTSim from './Pages/ProductPages/QNTSim';
import QBiosensor from './Pages/ProductPages/QBiosensor';
import QMemory from './Pages/ProductPages/QMemory';
import QCluster from './Pages/ProductPages/QCluster';
import QubitIQ from './Pages/ProductPages/QubitIQ';
import QuantumRepeater from './Pages/ProductPages/QuantumRepeater';
import QuantumGravimeter from './Pages/ProductPages/QuantumGravimeter';
import RydbergSensor from './Pages/ProductPages/RygbergSensor';
import QAIGHome from './Pages/QuantumAIGlobal/Home';
import { useEffect } from "react";


function useDynamicBranding() {
  useEffect(() => {
    const favicon = document.querySelector("link[rel='icon']");
    const title = document.querySelector("title");
    const meta = document.querySelector("meta[name='description']");

    if (currentSite === "site2") {
      favicon.href = process.env.PUBLIC_URL + "/QuantumAILogo.png";
      title.innerText = "Quantum AI Global";
          

    } else {
      favicon.href = process.env.PUBLIC_URL + "/logo.png";
      title.innerText = "Qulabs";
       
    }
    if (meta) {
      meta.setAttribute(
        "content",
        currentSite === "site2"
          ? "Leading the way in Quantum & AI Innovations."
          : "We Engineer Solutions To Complex Problems Using Quantum Principle",
      );
    }
  }, []);
}

// Authentication Context
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(true); // Replace with real auth logic
  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => useContext(AuthContext);

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Define protected paths
  const protectedPaths = [
    "/Company/Aboutus",
    "/Company/Contactus",
    "/Products/Hardware",
    "/Products/Software",
    "/Products/ResearchandDevelopment",
    "/Services",
    "/Partners",
    "/Ourip",
    "/Resources",
    "/Products/QForte",
    "/Products/ECDL",
    "/Products/QuantumBiosernsor",
    "/Products/QuantumMemory",
    "/Products/EPSQKD",
    "/Products/QNTSim",
    "/Products/QCluster",
    "/Products/QubitIQ",
    "/Products/QuantumRepeater",
    "/Products/QuantumGravimeter",
    "/Products/RydbergSensor",
    "/QuantumAIGlobal"
  ];

  // Check if the current path is protected and if the user is authenticated
  if (protectedPaths.includes(location.pathname) && !isAuthenticated) {
    return <Navigate to="/404" />;
  }

  return children;
};






export default function App() {
    useDynamicBranding();
  return (
    <AuthProvider>
      <BrowserRouter>
       
        <Routes>
          <Route
            path="/"
            element={currentSite === "site2" ? <QAIGHome /> : <Home />}
          />
          <Route
            path="/Company/Aboutus"
            element={
              <ProtectedRoute>
                <Aboutus />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Company/Contactus"
            element={
              <ProtectedRoute>
                <Contactus />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/Hardware"
            element={
              <ProtectedRoute>
                <Hardware />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/Software"
            element={
              <ProtectedRoute>
                <Software />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/ResearchandDevelopment"
            element={
              <ProtectedRoute>
                <ResearchandDevelopment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Services"
            element={
              <ProtectedRoute>
                <Services />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Partners"
            element={
              <ProtectedRoute>
                <Partners />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Ourip"
            element={
              <ProtectedRoute>
                <Ourips />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Publications"
            element={
              <ProtectedRoute>
                <Publications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/QForte"
            element={
              <ProtectedRoute>
                <QForte />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/ECDL"
            element={
              <ProtectedRoute>
                <ECDL />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/QuantumBiosernsor"
            element={
              <ProtectedRoute>
                <QBiosensor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/QuantumMemory"
            element={
              <ProtectedRoute>
                <QMemory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/EPSQKD"
            element={
              <ProtectedRoute>
                <EPSQKD />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/QNTSim"
            element={
              <ProtectedRoute>
                <QNTSim />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/QCluster"
            element={
              <ProtectedRoute>
                <QCluster />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/QubitIQ"
            element={
              <ProtectedRoute>
                <QubitIQ />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/QuantumRepeater"
            element={
              <ProtectedRoute>
                <QuantumRepeater />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/QuantumGravimeter"
            element={
              <ProtectedRoute>
                <QuantumGravimeter />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Products/RydbergSensor"
            element={
              <ProtectedRoute>
                <RydbergSensor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/QuantumAIGlobal"
            element={
              <ProtectedRoute>
                <QAIGHome />
              </ProtectedRoute>
            }
          />
          <Route path="/404" element={<PageNotFound />} />
          <Route path="*" element={<PageNotFound />} />{" "}
          {/* Catch-all for unmatched routes */}
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

